import { inject, Injectable } from '@angular/core';

import { WindowRef } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DpCurrentLocationService {
  readonly #windowRef = inject(WindowRef);

  getCurrentLocation(options?: PositionOptions): Observable<GeolocationPosition> {
    return new Observable((observer) => {
      this.#windowRef.nativeWindow?.navigator?.geolocation?.getCurrentPosition(
        (position: GeolocationPosition) => {
          observer.next(position);
          observer.complete();
        },
        (result: GeolocationPositionError) => {
          observer.error(result);
          observer.complete();
        },
        options,
      );
    });
  }
}
